import React from 'react';
import ClipboardTextarea from './ClipboardTextarea/ClipboardTextarea';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';

type Props = {
  closeModal: () => void;
  isPublicMap: boolean;
  currentProcessMapId: string;
  open: boolean;
};

const ShareModal = (props: Props) => {
  const { open, closeModal, isPublicMap, currentProcessMapId } = props;

  const mapRoute = 'processmaps';
  const mapUrl = `${window.location.origin}/${mapRoute}/${currentProcessMapId}`;
  const publicMapUrl = mapUrl.replace(mapRoute, 'map');
  const iframeUrl = `<iframe width="650" height="800" src="${publicMapUrl}" frameborder="0"></iframe>`;

  const defaultTextToDisplay =
    'Public sharing is not enabled for this process map.';

  const { enablePublicProcessMaps } =
    useService<SharedAngular.APP_CONFIG>('APP_CONFIG');

  return (
    open && (
      <Modal
        onClose={closeModal}
        hideActionButton={true}
        onCancelClick={closeModal}
        cancelButtonText="Done"
      >
        <div className="share-modal-container">
          <p className="share-modal-heading">Share Process Map</p>
          <ClipboardTextarea
            disabled={false}
            label="Share With a Colleague"
            textareaId="shareWithColleague"
            textareaValue={mapUrl}
          />
          <div>
            <ClipboardTextarea
              label="Public Link"
              textareaId="shareAsPublicMap"
              textareaValue={
                isPublicMap && enablePublicProcessMaps
                  ? publicMapUrl
                  : defaultTextToDisplay
              }
              disabled={!isPublicMap || !enablePublicProcessMaps}
            />
            <ClipboardTextarea
              label="Embed Code"
              textareaId="embeddedIframeUrl"
              textareaValue={
                isPublicMap && enablePublicProcessMaps
                  ? iframeUrl
                  : defaultTextToDisplay
              }
              disabled={!isPublicMap || !enablePublicProcessMaps}
            />
          </div>
        </div>
      </Modal>
    )
  );
};

export default ShareModal;
